import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ClockingRecordsSearchSchema } from '../-zod-schema';

/**
 * 日次の打刻一覧。`records/` の index は勤怠締め台帳（締め単位）になったため、
 * 締めの中身である日次実績はこのルートが受け持つ。
 *
 * 一覧の実装（`-api` / `-columns` / `-components` / `-hooks` / `-query` / `-types`）は
 * 親の `records/` 直下に置いたまま。従業員別の出勤簿（`records/$employeeId`）が
 * 同じ日次行の型・カラム・正規化を共有しているため、片方のルート配下へ寄せると
 * もう片方が兄弟ルートの内部を覗くことになる。
 */
export const Route = createFileRoute('/_staff/attendances/_layout/records/daily/')({
  validateSearch: zodValidator(ClockingRecordsSearchSchema)
});